import Ajax from 'js/utils/ajax/ajax';

import { ApiLabelGenerationHistory } from 'src/interfaces/interfaces.generated';

export const getLabelHistory = (page: number): Promise<ApiLabelGenerationHistory> =>
  Ajax.get(`/labels/v1/history?page=${page}`);
